const isValidPrefixMAMLData = (input: string): boolean => {
	const regex: RegExp = /^(?:m\d{5,}|a\d{5,}|ml\d{4,}|m[a-zA-Z]{2}\d{3,})$/i;
	return regex.test(input);
};

export { isValidPrefixMAMLData };
